import {
    query,
    collection,
    where,
    getDocs,
    getDoc,
    doc,
    updateDoc,
    arrayUnion,
    addDoc,
    deleteDoc,
    arrayRemove,
} from "firebase/firestore";
import db from "../firebase";

export const fetchBuildings = async (
    orgIDs,
    setBuildings,
    setBuildingsLoading,
) => {
    // fetch buildings info
    let buildingsArr = [];
    let buildingData;
    let buildingsQ = query(collection(db, 'buildings'), where('orgID', 'in', orgIDs));
    setBuildingsLoading(true);
    const buildingsSnapshot = await getDocs(buildingsQ);

    if (buildingsSnapshot.empty) {
        // console.log('[fetch buildings] no buildings in ', orgIDs);
    } else {
        buildingsSnapshot.forEach((doc) => {
            buildingData = doc.data();
            buildingsArr.push(buildingData);
        });
    };
    // sort by name
    buildingsArr.sort((a, b) => {
        const nameA = a.name.toUpperCase(); // ignore upper and lowercase
        const nameB = b.name.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
            return -1;
        };
        if (nameA > nameB) {
            return 1;
        };
        // names must be equal
        return 0;
    });

    setBuildings([...buildingsArr]); // Replace the old outlets with the new ones
    localStorage.setItem("buildings", JSON.stringify(buildingsArr));
    setBuildingsLoading(false);
};

export const outletConflicts = (outlets, currentBuilding, layoutProps) => {
    return layoutProps.buildings.some(building => {
        // skips building being edited
        if (currentBuilding.buildingID === '') {

        }else if (
            currentBuilding.buildingID &&
            building.buildingID === currentBuilding.buildingID
        ) {
            return false;
        };
        // checks for buildings that already include that outlet        
        const outletConflict = outlets.some(outlet => building?.devices.includes(outlet));
        return outletConflict;
    });
};

export const handleAddOutletsToBuilding = async (outlets, building, layoutProps, setOutletError, setSubmitLoading, closeOutletModal, selectedOutletObjects, removedOutlets) => {
    setSubmitLoading(true);
    if (outletConflicts(outlets, building, layoutProps)) {
        setOutletError(true);
        setSubmitLoading(false);
        return false;
    };
    try {
        const buildingRef = doc(db, 'buildings', building.buildingID);
        const outletIds = selectedOutletObjects.map(outlet => outlet.id); // Extract the ids

        await updateDoc(buildingRef, {
            devices: outlets,
        });
        // Loop through each outlet and update its buildingID field
        for (const outlet of selectedOutletObjects) {
            const outletRef = doc(db, 'outlets', outlet.uid); // Reference to each outlet document
            await updateDoc(outletRef, {
                building: building.buildingID // Set the buildingID field to the building document's ID
            });
        };
        // Loop through each outlet and update its buildingID field when removed
        for (const outlet of removedOutlets) {
            const outletRef = doc(db, 'outlets', outlet.uid); // Reference to each outlet document
            await updateDoc(outletRef, {
                building: '' // Set the buildingID field to empty
            });
        };
    } catch (error) {
        console.error('Failed to add outlets to building:', error)
    } finally {
        setSubmitLoading(false);
        closeOutletModal();
    };
};

export const updateBuildingRate = async (buildingID, newRate) => {
    try {
        const buildingDocRef = doc(db, "buildings", buildingID);
        await updateDoc(buildingDocRef, { rate: newRate });
    } catch (error) {
        throw new Error("Failed to update rate: " + error.message);
    };
};

export const nameConflicts = (buildingID, newName, layoutProps) => {
    return layoutProps.buildings.some(building => {
        // Skip the building being edited
        if (buildingID === '') {

        } else if (buildingID && building.buildingID === buildingID) {
            return false;
        };
        // Check if newName matches any existing building name
        return building.name === newName;
    });
};
export const updateBuildingName = async (buildingID, newName, layoutProps,) => {
    if (nameConflicts(buildingID, newName, layoutProps)) {
        return false;
    };
    try {
        // NOTE: add check for if buildings array contains new name
        const buildingDocRef = doc(db, "buildings", buildingID);
        await updateDoc(buildingDocRef, { name: newName });
    } catch (error) {
        throw new Error("Failed to update name: " + error.message);
    };
};

export const handleBuildingCreate = async (buildingData, layoutProps, setOutletError, setNameError) => {
    // check name and outlet conflicts
    if (nameConflicts('', buildingData.name, layoutProps)) {
        setNameError(true);
        return false;
    };
    if (outletConflicts(buildingData.outlets, buildingData, layoutProps)) {
        setOutletError(true);
        return false;
    };
    try {
        const buildingDocRef = await addDoc(
            collection(db, 'buildings'),
            {
                name: buildingData.name,
                rate: Number(buildingData.rate).toFixed(2),
                orgID: buildingData.orgID,
                devices: buildingData.outlets,
                // buildingID: buildingData.buildingData,
            }
        );
        const newBuildingID = buildingDocRef.id;
        await updateDoc(buildingDocRef, {
            buildingID: newBuildingID,
        });
        
        const buildingOutletObjects = layoutProps.outlets.filter(outlet =>
            buildingData.outlets.includes(outlet.id)
        );
        for (const outlet of buildingOutletObjects) {
            const outletRef = doc(db, 'outlets', outlet.uid);
            await updateDoc(outletRef, {
                building: newBuildingID,
            });
        };
        const orgDocRef = doc(db, 'organizations', buildingData.orgID);
        await updateDoc(orgDocRef, {
            buildings: arrayUnion(newBuildingID)
        });
    } catch (error) {
        console.log('Error Creating Building: ', error);
    };
};

export const handleBuildingDelete = async (buildingData, layoutProps) => {
    try{
        const buildingOutletObjects = layoutProps.outlets.filter(outlet =>
            buildingData.devices.includes(outlet.id)
        );
        for (const outlet of buildingOutletObjects){
            const outletRef = doc(db, 'outlets', outlet.uid);
            await updateDoc(outletRef,{
                building: '',
            });
        };
        const buildingID = buildingData.buildingID;
        const orgRef = doc(db, 'organizations', buildingData.orgID);
        await updateDoc(orgRef,{
            buildings: arrayRemove(buildingID)
        });
        const buildingRef = doc(db, 'buildings', buildingID);
        await deleteDoc(buildingRef);
    }catch(error){
        console.log('Error Deleting Building: ', error);
    };
};